import GenericErrorMessage from "./GenericErrorMessage";

export default GenericErrorMessage;
